import { EmployeeInvitationStatusTypes, SubscriberProgress } from 'types/electionService';
import { remindCompleteProfile } from 'api/operations/electionService';
import { bpHistory } from 'global/bpHistory';
import { toastManager } from '@insurancemenu/imenu-components-lib/dist/components/Toast/toastManager';
import { ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { TabId, ElectionsTabId } from 'store/modules/full-employee-form/types';
import { EmployeeActionObject } from 'store/modules/add-employees/actionRules';

export enum EnrollmentEmployeeAction {
  REMIND_COMPLETE_PROFILE = 'REMIND_COMPLETE_PROFILE',
  EMPLOYEE_PROFILE = 'EMPLOYEE_PROFILE',
  MANAGE_DEPENDENTS = 'MANAGE_DEPENDENTS',
  ELECTIONS = 'ELECTIONS',
}

export const enrollmentEmployeeActions: EmployeeActionObject[] = [
  {
    type: EnrollmentEmployeeAction.REMIND_COMPLETE_PROFILE,
    name: 'Remind Complete Profile',
    showForStatuses: [EmployeeInvitationStatusTypes.REGISTERED, EmployeeInvitationStatusTypes.INVITED],
    showForProgress: [SubscriberProgress.INCOMPLETE_PROFILE],
    handler: async (context): Promise<void> => {
      await remindCompleteProfile(context.static.employeeData.id);
      toastManager.addToast('Reminder sent successfully!', ToastColorTypes.SUCCESS);
    },
  },
  {
    type: EnrollmentEmployeeAction.EMPLOYEE_PROFILE,
    name: 'Employee Profile',
    handler: (context): void => {
      bpHistory.push(
        `/full-employee-form/${context.static.groupId}/${context.static.periodId}?subscriberId=${context.static.employeeData.id}`,
      );
    },
  },
  {
    type: EnrollmentEmployeeAction.MANAGE_DEPENDENTS,
    name: 'Manage Dependents',
    handler: (context): void => {
      bpHistory.push(
        `/full-employee-form/${context.static.groupId}/${context.static.periodId}?subscriberId=${context.static.employeeData.id}&activeTabId=${TabId.DEPENDENTS}`,
      );
    },
  },
  {
    type: EnrollmentEmployeeAction.ELECTIONS,
    name: 'Manage Elections',
    handler: (context): void => {
      bpHistory.push(
        `/full-employee-form/${context.static.groupId}/${context.static.periodId}?subscriberId=${context.static.employeeData.id}&activeTabId=${ElectionsTabId.ELECTIONS}`,
      );
    },
  },
];
